import { Components, Theme } from '@mui/material/styles';

export const flowFilledInput: Components<Theme>['MuiFilledInput'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      '&, &:hover, &.Mui-disabled, &.Mui-focused': {
        color: 'inherit',
        transition: 'inherit',
        backgroundColor:
          theme.palette.mode === 'dark' ? theme.palette.surface.primary : theme.palette.transparent.primary,
        // underline
        '&:before': {
          transition: 'inherit',
          borderBottomStyle: 'solid',
          borderColor: 'currentColor',
        },
        // active underline
        '&:after': {
          borderColor: 'currentColor',
          // remove animated transition of appearing border
          transition: 'none',
        },
      },
      '&.Mui-error:not(.Mui-disabled)': {
        '&:before, &:after': {
          color: theme.palette.error.main,
        },
      },
    }),
    input: ({ ownerState }) => ({
      paddingTop: '24px',
      paddingBottom: '8px',
      ...(ownerState.hiddenLabel && {
        paddingTop: '18px',
        paddingBottom: '14px',
      }),
      ...(ownerState.size === 'small' && {
        paddingTop: '22px',
        paddingBottom: '4px',
        ...(ownerState.hiddenLabel && {
          paddingTop: '14px',
          paddingBottom: '12px',
        }),
      }),
      ...(ownerState.multiline && {
        paddingTop: '0',
        paddingBottom: '0',
      }),
    }),
    multiline: ({ ownerState }) => ({
      paddingTop: '24px',
      paddingBottom: '8px',
      ...(ownerState.hiddenLabel && {
        paddingTop: '18px',
        paddingBottom: '14px',
      }),
      ...(ownerState.size === 'small' && {
        paddingTop: '22px',
        paddingBottom: '4px',
        ...(ownerState.hiddenLabel && {
          paddingTop: '14px',
          paddingBottom: '12px',
        }),
      }),
    }),
  },
};
